import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopeOpenSolidTemplateIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m15.3 7-8.5 6.2 7 5.1.8.4v7.9H6.8A3 3 0 0 1 4 23.8V13.2q0-1.5 1.1-2.3l8.7-6.4a3 3 0 0 1 3 0l8.6 6.4q.6.3.8.9H22zm1.4 9c0-1.2 1-2.1 2.1-2.1h7c1.3 0 2.2 1 2.2 2.1v9.9c0 1.2-1 2.1-2.1 2.1h-7c-1.2 0-2.2-1-2.2-2.1zm3.5.7a1 1 0 1 0 0 2.1h4.3a1 1 0 1 0 0-2zm0 4.2a1 1 0 1 0 0 2.2h2.5a1 1 0 1 0 0-2.2z" })
});
export default SvgEnvelopeOpenSolidTemplateIcon;
